var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-block btn-default",class:{
		'disabled': _vm.disabled || _vm.loading,
		'btn-primary': _vm.btnPrimary,
		'hide': _vm.btnHide
	},attrs:{"tabindex":"1","id":_vm.btnId,"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.handleClicked}},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0),_vm._m(1)]):_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingLeft"},[_c('div')])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingRight"},[_c('div')])
}]

export { render, staticRenderFns }